/**
 * Whether a signed-in user should be prompted to set a password (magic-link
 * migration). OAuth-only accounts skip; users who already completed migration
 * or deferred within the window also skip.
 */
export function userNeedsPasswordMigration(authUser, userData) {
  if (!authUser?.email) return false;
  if (userData?.passwordMigrationComplete === true) return false;

  const deferredUntil = userData?.passwordMigrationDeferredUntil;
  if (deferredUntil && new Date(deferredUntil) > new Date()) return false;

  const providers = (authUser.providerData || [])
    .map((p) => p.providerId)
    .filter(Boolean);

  if (providers.length === 0) {
    // Email-based session with no provider metadata yet — treat as legacy email.
    return true;
  }

  const hasOAuth = providers.some((p) => p === 'google.com' || p === 'microsoft.com');
  if (hasOAuth) return false;

  return providers.includes('password');
}
